import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="bg-[#FF6B35] py-3 md:py-4" data-id="element-20">
      <div className="container mx-auto px-4 text-center text-white" data-id="element-21">
        <p className="font-poppins font-bold mb-2 md:mb-3" data-id="element-22">
          ⏰ PRECIO ESPECIAL CIERRA EN:
        </p>
        <div className="flex justify-center gap-4 font-poppins font-black text-3xl md:text-5xl mb-2 md:mb-3" data-id="element-23">
          <div className="bg-white/20 px-4 py-2 rounded-lg backdrop-blur-sm" data-id="element-24">
            {String(timeLeft.hours).padStart(2, '0')}
          </div>
          <span className="self-center" data-id="element-25">:</span>
          <div className="bg-white/20 px-4 py-2 rounded-lg backdrop-blur-sm" data-id="element-26">
            {String(timeLeft.minutes).padStart(2, '0')}
          </div>
          <span className="self-center" data-id="element-27">:</span>
          <div className="bg-white/20 px-4 py-2 rounded-lg backdrop-blur-sm" data-id="element-28">
            {String(timeLeft.seconds).padStart(2, '0')}
          </div>
        </div>
        <p className="font-poppins font-bold text-sm md:text-base" data-id="element-29">
          ⚠️ Después sube $8.000 ARS. No vuelve.
        </p>
      </div>
    </section>;
}